export const dashboardPagePaths: string[] = [
  'client',
  'client-parent',
  'creditor',
  'debtor',
  'estate',
  'landlord',
  'lease',
  'main',
  'manager',
  'property',
  'supplier',
  'tenant',
  'tenant-parent',
];
